const getNonEmptyFieldsCount = (x: any) => Object.values(x).filter(Boolean).length;
const isEmpty = (x: any) => getNonEmptyFieldsCount(x) === 0;

export { isEmpty, getNonEmptyFieldsCount };
